// India-first formatting utilities. Locale en-IN, currency INR, timezone Asia/Kolkata.
// Built so additional locales/currencies can be added later without refactoring.
const LOCALE = "en-IN";
const CURRENCY = "INR";
const TIMEZONE = "Asia/Kolkata";

const _inr = new Intl.NumberFormat(LOCALE, { style: "currency", currency: CURRENCY, maximumFractionDigits: 0 });
const _num = new Intl.NumberFormat(LOCALE);

export function formatINR(value) {
  const n = Number(value);
  if (value == null || Number.isNaN(n)) return "—";
  return _inr.format(n);
}

// Indian numbering system grouping (1,00,000 etc.)
export function formatIndianNumber(value) {
  const n = Number(value);
  if (value == null || Number.isNaN(n)) return "—";
  return _num.format(n);
}

// Abbreviated Indian currency using Lakh / Crore (not K/M/B).
export function formatINRCompact(value) {
  const n = Number(value);
  if (value == null || Number.isNaN(n)) return "—";
  const abs = Math.abs(n);
  if (abs >= 1e7) return `₹${(n / 1e7).toFixed(2)} Crore`;
  if (abs >= 1e5) return `₹${(n / 1e5).toFixed(2)} Lakh`;
  return formatINR(n);
}

export function formatDateIN(date) {
  const d = date ? new Date(date) : new Date();
  return new Intl.DateTimeFormat(LOCALE, { day: "2-digit", month: "2-digit", year: "numeric", timeZone: TIMEZONE }).format(d);
}

export function formatDateLongIN(date) {
  const d = date ? new Date(date) : new Date();
  return new Intl.DateTimeFormat(LOCALE, { day: "numeric", month: "long", year: "numeric", timeZone: TIMEZONE }).format(d);
}

export const LOCALE_CONFIG = { locale: LOCALE, currency: CURRENCY, timezone: TIMEZONE };
